module.exports = {
  "FoodB_2_Created_successfully_IqRa": "¡Creada correctamente!",
  "soda-d-i18n---下载": "Descargar",
  "FoodB_statistics_Refresh_qDDP": "Actualizar",
  "FoodC_sales_Not_set_AJmE": "Más tarde",
  "FoodB_I_Exit_sfrY": "Cerrar sesión",
  "soda-b-web-i18n---加载中": "Cargando...",
  "FoodD_one_Try_again_qZka": "Inténtalo de nuevo",
  "FoodB_modification_Modified_sTAw": "Edición completada"
}